export default __webpack_public_path__ + "static/media/diamond-clarity-1@2x.6821b705.png";